import { Action } from '@ngrx/store';

export const /** @type {?} */ PERFORM_ACTION = 'PERFORM_ACTION';
export const /** @type {?} */ RESET = 'RESET';
export const /** @type {?} */ ROLLBACK = 'ROLLBACK';
export const /** @type {?} */ COMMIT = 'COMMIT';
export const /** @type {?} */ SWEEP = 'SWEEP';
export const /** @type {?} */ TOGGLE_ACTION = 'TOGGLE_ACTION';
export const /** @type {?} */ SET_ACTIONS_ACTIVE = 'SET_ACTIONS_ACTIVE';
export const /** @type {?} */ JUMP_TO_STATE = 'JUMP_TO_STATE';
export const /** @type {?} */ IMPORT_STATE = 'IMPORT_STATE';
export class PerformAction implements Action {
  readonly type = PERFORM_ACTION;
/**
 * @param {?} action
 * @param {?=} timestamp
 */
constructor(public action: Action,
public timestamp?: number) {
    if (typeof action.type === 'undefined') {
      throw new Error(
        'Actions may not have an undefined "type" property. ' +
          'Have you misspelled a constant?'
      );
    }
  }
}

function PerformAction_tsickle_Closure_declarations() {
/** @type {?} */
PerformAction.prototype.type;
/** @type {?} */
PerformAction.prototype.action;
/** @type {?} */
PerformAction.prototype.timestamp;
}

export class Reset implements Action {
  readonly type = RESET;
/**
 * @param {?=} timestamp
 */
constructor(public timestamp?: number) {}
}

function Reset_tsickle_Closure_declarations() {
/** @type {?} */
Reset.prototype.type;
/** @type {?} */
Reset.prototype.timestamp;
}

export class Rollback implements Action {
  readonly type = ROLLBACK;
/**
 * @param {?=} timestamp
 */
constructor(public timestamp?: number) {}
}

function Rollback_tsickle_Closure_declarations() {
/** @type {?} */
Rollback.prototype.type;
/** @type {?} */
Rollback.prototype.timestamp;
}

export class Commit implements Action {
  readonly type = COMMIT;
/**
 * @param {?=} timestamp
 */
constructor(public timestamp?: number) {}
}

function Commit_tsickle_Closure_declarations() {
/** @type {?} */
Commit.prototype.type;
/** @type {?} */
Commit.prototype.timestamp;
}

export class Sweep implements Action {
  readonly type = SWEEP;
}

function Sweep_tsickle_Closure_declarations() {
/** @type {?} */
Sweep.prototype.type;
}

export class ToggleAction implements Action {
  readonly type = TOGGLE_ACTION;
/**
 * @param {?} id
 */
constructor(public id: number) {}
}

function ToggleAction_tsickle_Closure_declarations() {
/** @type {?} */
ToggleAction.prototype.type;
/** @type {?} */
ToggleAction.prototype.id;
}

export class SetActionsActive implements Action {
  readonly type = SET_ACTIONS_ACTIVE;
/**
 * @param {?} start
 * @param {?} end
 * @param {?=} active
 */
constructor(
public start: number,
public end: number,
public active: boolean = true
  ) {}
}

function SetActionsActive_tsickle_Closure_declarations() {
/** @type {?} */
SetActionsActive.prototype.type;
/** @type {?} */
SetActionsActive.prototype.start;
/** @type {?} */
SetActionsActive.prototype.end;
/** @type {?} */
SetActionsActive.prototype.active;
}

export class JumpToState implements Action {
  readonly type = JUMP_TO_STATE;
/**
 * @param {?} index
 */
constructor(public index: number) {}
}

function JumpToState_tsickle_Closure_declarations() {
/** @type {?} */
JumpToState.prototype.type;
/** @type {?} */
JumpToState.prototype.index;
}

export class ImportState implements Action {
  readonly type = IMPORT_STATE;
/**
 * @param {?} nextLiftedState
 */
constructor(public nextLiftedState: any) {}
}

function ImportState_tsickle_Closure_declarations() {
/** @type {?} */
ImportState.prototype.type;
/** @type {?} */
ImportState.prototype.nextLiftedState;
}


export type All =
  | PerformAction
  | Reset
  | Rollback
  | Commit
  | Sweep
  | ToggleAction
  | SetActionsActive
  | JumpToState
  | ImportState;



// WEBPACK FOOTER //
// ../../../modules/store-devtools/src/actions.ts